import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  materialTypeService,
  measurementTypeService,
  packingTypeService,
  stockClassificationService,
  supplierService,
} from "_services";
import TabMenu from "./TabMenu";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import TableForm from "./TableForm";

let lineIndex = 0;

function Edit({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [stockType, setStockType] = useState({});
  const [packingTypes, setPackingTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  //const [materialLines, setMaterialLines] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const classificationData =
        await stockClassificationService.getSuggestion();
      setStockClasses(classificationData.content);
      materialTypeService
        .getById(id)
        .then((x) => {
          let data = x.content;
          setIsLoading(false);
          setStockType(x.content);
          //setMaterialLines(x.content.materials);
          if (x.content.stockClass.name === "FINISHED PRODUCT") {
            const rawMaterialClass = classificationData.content.find(
              (sc) => sc.name === "RAW MATERIAL"
            );
            getRawMaterials(rawMaterialClass);
          }
          onFill(data);
        })
        .catch((errorInfo) => {
          setIsLoading(false);
          message.error(`${errorInfo}`);
        });
      getPackingTypes();  
      getMeasurements();
    })();
  }, []);

  const getPackingTypes = () => {
    packingTypeService.getSuggestion().then((x) => {
      setPackingTypes(x.content);
    });
  };

  const getRawMaterials = (classification) => {
    setIsLoading(true);
    materialTypeService
      .search(`?stockClassId=${classification.id}`)
      .then((x) => {
        setIsLoading(false);
        setRawMaterials(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getMeasurements = () => {
    measurementTypeService
      .getSuggestion()
      .then((x) => {
        setMeasurementTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const validateMaterialLines = (lines) => {
    let validLines = true;
    if (lines && lines.length > 0) {
      lines.forEach((line) => {
        if (
          !line.materialType ||
          !line.quantityPerUnit ||
          !line.conversionRatio ||
          !line.wastagePercentage ||
          !line.uom
        ) {
          validLines = false;
        }
      });
    }
    return validLines;
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        if (validateMaterialLines(values.materials)) {
          setIsUpdating(true);

          materialTypeService
            .update(id, values)
            .then(() => {
              message.success("Successfully updated!");
              setIsUpdating(false);
              //history.push(`${path}`);
            })
            .catch((error) => {
              setIsUpdating(false);
              message.error(`${error}`);
            });
        } else {
          message.error(
            "Please complete all the material lines with valid details"
          );
        }
      })
      .catch((error) => {
        // message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/material-types");
  };

  const shouldRenderTable = () => {
    const hasMaterials =
      stockType &&
      stockType.materials &&
      stockType.materials.length > 0 &&
      rawMaterials.length > 0 &&
      form.getFieldValue("materials");

    const isFinishedProduct =
      stockType?.stockClass?.name === "FINISHED PRODUCT";

    return hasMaterials || isFinishedProduct;
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          key="update-confirm"
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isUpdating}>
            Update
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-types">Material Type Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Material Type: {stockType.code}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <Spin tip="Loading..." spinning={isLoading}>
            <TabMenu menu="edit" id={id} />
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="code"
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input placeholder="HS Code" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="secondaryCode"
                    label="Customer Code"
                    rules={[
                      { required: true, message: "Customer Code is required" },
                    ]}
                  >
                    <Input placeholder="Customer Code" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["stockClass", "id"]}
                    label="Stock Classification"
                    rules={[
                      {
                        required: true,
                        message: "Stock classification is required",
                      },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {stockClasses.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  {/* <Form.Item
                    name={["supplier", "id"]}
                    label="Material Supplier"
                    rules={[
                      {
                        required: true,
                        message: "Material Supplier is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Material Supplier"
                    >
                      {materialSuppliers.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.name} ({t.code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["packingType", "id"]}
                    label="Packing Type"
                    rules={[
                      { required: true, message: "Packing type is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {packingTypes.length > 0 &&
                        packingTypes.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  {/* <Form.Item name={["qualityType", "id"]} label="Quality Type" rules={[
                    {
                      required: true,
                      message: "Quality Type is required",
                    },
                  ]}>
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Quality Type"
                    >
                      {qualityTypes.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.name} ({t.code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                </Col>
                <Col span={6}></Col>
              </Row>

              {stockType &&
                stockType.materials &&
                stockType.materials.length > 0 &&
                rawMaterials.length > 0 &&
                form.getFieldValue("materials") && (
                  <Form.Item name="materials">
                    <TableForm
                      materialTypes={rawMaterials}
                      measurementTypes={measurementTypes}
                    />
                  </Form.Item>
                )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Edit;
